import React from 'react';
import { useHeroVisibility } from '../../stores/index.js';

/**
 * Container-Slot, der für seine Seite registriert, ob das Keyvisual sichtbar ist.
 *
 * Ob eine Seite das Keyvisual zeigt, entscheidet die Route über `useHeroVisibility` und
 * nicht mehr ein Feld im Produktdeskriptor: die App reicht ihren Produktwert beim Aufbau
 * des Slots herein (`product.containers`), der Kern-Container kennt keinen Produktwert.
 *
 * @param {Function|object} WrappedComponent Kern-Container des Slots
 * @param {string} id Registrierungsschlüssel der Seite (z. B. `'ProjectList'`)
 * @param {boolean} visible Produktwert: `true` = Keyvisual auf dieser Seite zeigen
 */
const withHeroVisibility = (WrappedComponent, id, visible) => {
    const WithHeroVisibility = (props) => {
        useHeroVisibility(id, visible);
        return <WrappedComponent {...props} />;
    };

    WithHeroVisibility.displayName = `withHeroVisibility(${
        WrappedComponent.displayName || WrappedComponent.name || 'Component'
    })`;

    return WithHeroVisibility;
};

export default withHeroVisibility;
